import { render, staticRenderFns } from "./AcademicLoadPrerequisitesModal.vue?vue&type=template&id=3899bae0&scoped=true"
import script from "./AcademicLoadPrerequisitesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AcademicLoadPrerequisitesModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AcademicLoadPrerequisitesModal.vue?vue&type=style&index=0&id=3899bae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3899bae0",
  null
  
)

export default component.exports